import { render } from "./BaseBottomWindow.vue?vue&type=template&id=6b9f8e28"
import script from "./BaseBottomWindow.vue?vue&type=script&lang=js"
export * from "./BaseBottomWindow.vue?vue&type=script&lang=js"

import "./BaseBottomWindow.vue?vue&type=style&index=0&id=6b9f8e28&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__